import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const DriverOnly = ({ component: Component, ...props }) => {
  const { isDriver } = useAuth();

  if (!isDriver) return <Navigate to="/app/crm" replace />;

  return <Component {...props} />;
};

export default DriverOnly;

 